<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">折旧明细表</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <span class="label">期间：</span>
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">类别：</span>
            <Select v-model="typeId" :datas="typeOptions" keyName="id" titleName="name" :deletable="false"
                    style="width:180px"></Select>
            <span class="label">编号：</span>
            <input type="text" class="h-input h-input-s" style="width:140px" placeholder="编号或名称" v-model="code">
            <span class="label">部门：</span>
            <Select v-model="deptId" :datas="deptOptions" keyName="id" titleName="name" :deletable="false"
                    style="width:180px"></Select>
            <Button color="primary" size="s" @click="loadList">查询</Button>
            <Button size="s" @click="exportCsv">导出</Button>
            <Button size="s" @click="printPage">打印</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:90px">会计期间</th>
                    <th style="width:100px">资产编号</th>
                    <th style="width:130px">资产类别</th>
                    <th style="min-width:130px">资产名称</th>
                    <th style="width:110px">规格型号</th>
                    <th style="width:120px">使用部门</th>
                    <th style="width:110px">资产原值</th>
                    <th style="width:110px">本期折旧</th>
                    <th style="width:120px">本年累计折旧</th>
                    <th style="width:110px">累计折旧</th>
                    <th style="width:100px">减值准备</th>
                    <th style="width:110px">资产净值</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in datas" :key="i">
                    <td>{{item.period}}</td>
                    <td>{{item.assetCode}}</td>
                    <td>{{item.typeName}}</td>
                    <td>{{item.assetName}}</td>
                    <td>{{item.spec}}</td>
                    <td>{{item.deptName}}</td>
                    <td align="right">{{item.originalValue|numFormat}}</td>
                    <td align="right">{{item.depreciationAmount|numFormat}}</td>
                    <td align="right">{{item.yearAmount|numFormat}}</td>
                    <td align="right">{{item.accumulatedAmount|numFormat}}</td>
                    <td align="right">{{item.impairment|numFormat}}</td>
                    <td align="right">{{item.netValue|numFormat}}</td>
                </tr>
                <tr v-if="!datas.length">
                    <td colspan="12" class="text-center padding">暂无数据</td>
                </tr>
                <tr class="total" v-else>
                    <td colspan="6" align="center">合计</td>
                    <td align="right">{{total('originalValue')|numFormat}}</td>
                    <td align="right">{{total('depreciationAmount')|numFormat}}</td>
                    <td align="right">{{total('yearAmount')|numFormat}}</td>
                    <td align="right">{{total('accumulatedAmount')|numFormat}}</td>
                    <td align="right">{{total('impairment')|numFormat}}</td>
                    <td align="right">{{total('netValue')|numFormat}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </app-content>
</template>

<script>
const KEYS = ['originalValue', 'depreciationAmount', 'yearAmount', 'accumulatedAmount', 'impairment', 'netValue'];

export default {
    name: 'AssetsDepreciation',
    data() {
        const now = new Date();
        return {
            datas: [],
            p1: now,
            p2: now,
            typeId: null,
            deptId: null,
            code: '',
            typeOptions: [],
            deptOptions: []
        };
    },
    methods: {
        fmtPeriod(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        },
        loadOptions() {
            this.$api.assets.assets.options().then(({ data }) => {
                this.typeOptions = [{ id: null, name: '全部' }].concat(data.types || []);
                this.deptOptions = [{ id: null, name: '全部' }].concat(
                    (data.depts || []).map(d => ({ id: d.id, name: d.code ? `${d.code} ${d.name}` : d.name })));
            });
        },
        loadList() {
            this.$api.assets.assets.depList({
                p1: this.fmtPeriod(this.p1),
                p2: this.fmtPeriod(this.p2),
                typeId: this.typeId,
                deptId: this.deptId,
                code: this.code
            }).then(({ data }) => {
                this.datas = data || [];
            });
        },
        total(field) {
            return this.datas.reduce((s, d) => s + Number(d[field] || 0), 0);
        },
        exportCsv() {
            const head = ['会计期间', '资产编号', '资产类别', '资产名称', '规格型号', '使用部门',
                '资产原值', '本期折旧', '本年累计折旧', '累计折旧', '减值准备', '资产净值'];
            const keys = ['period', 'assetCode', 'typeName', 'assetName', 'spec', 'deptName'].concat(KEYS);
            const rows = this.datas.map(d => keys.map(k => d[k]));
            rows.push(['合计'].concat(KEYS.map(k => this.total(k))));
            const csv = [head].concat(rows).map(r => r.map(c => `"${c == null ? '' : c}"`).join(',')).join('\r\n');
            this.download(`折旧明细表_${this.fmtPeriod(this.p1)}_${this.fmtPeriod(this.p2)}.csv`, '\ufeff' + csv);
        },
        download(name, content) {
            const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        printPage() { window.print(); }
    },
    mounted() {
        this.loadOptions();
        this.loadList();
    }
};
</script>

<style scoped lang="less">
    .filter-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .label { margin-left: 6px; }
    }

    .grid {
        width: 100%;
        border-collapse: collapse;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
            white-space: nowrap;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }

        .total td { background-color: #f5f5f5; font-weight: bold; }
    }
</style>
